var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.758.925a1.167 1.167 0 011.65 0l5.25 5.25a1.167 1.167 0 010 1.65l-5.25 5.25a1.166 1.166 0 11-1.65-1.65l3.259-3.258H1.167a1.167 1.167 0 010-2.334h15.85l-3.259-3.258a1.167 1.167 0 010-1.65z","fill":"#131618"}));
}

Arrow.defaultProps = {"width":"21","height":"14","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
